module.exports = __webpack_public_path__ + "static/media/preview.b4ee5824.png";